module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "epub:type": "pagebreak",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Copyright © 2022 by Kerry Dolan")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN 978-1-61376-914-0 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cover design by Sally Nichols")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover art: "), _c('i', [_vm._v("background texture,")]), _vm._v(" oil painting by Nuk2013, Shutterstock.com;")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('i', [_vm._v("Geometric Waves,")]), _vm._v(" by Curly Pat, Shutterstock.com.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Dolan, Kerry, author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Safe places : stories / Kerry Dolan.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Amherst : University of Massachusetts Press, [2022] | Series: Juniper prize for fiction")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2021054641 (print) | LCCN 2021054642 (ebook) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   9781625346391 (paperback) | ISBN 9781613769133 (ebook) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   9781613769140 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCGFT: Short stories.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC PS3604.O4266 S24 2022  (print) | LCC PS3604.O4266")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   (ebook) | DDC 813/.6—dc23/eng/20211108")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at https://lccn.loc.gov/2021054641")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC ebook record available at https://lccn.loc.gov/2021054642")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("British Library Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalog record for this book is available from the British Library.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-810baa4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/umaDOLAN0004.vue
// module id = 66
// module chunks = 0